import './BetbookProfileDialog.less';

import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { DialogBody, Docked } from '@/ui/dialogs/Dialog';
import { scrollBody } from '@/common/client';
import BetbookProfile from 'nike-ui/src/components/betbook-profile/views/BetbookProfile';
import { getConfigProperty } from '@/common/oldMobile';
import { BetbookProfileProvider } from 'nike-ui/src/components/betbook-profile/BetbookProfileContext';
import { betbookSubscription$ } from '@/notifications/subs';
import { profile$, setProfile } from 'nike-ui/src/components/betbook-profile/handlers-subs';
import { COMMUNITY_POSTS_AUTHOR } from '@/routing/routes';
import { accountUserData$ } from '@/account/subs';
import forumClient from '@/_http/axiosForumClient';
import RequestNotificationPermission from '@/notifications/components/RequestNotificationPermission';

function loadProfile(nickname) {
    forumClient.get(`/v5/betbook/authors/${nickname}/profile`).then(data => dispatch(setProfile(data)));
}

// noinspection JSUnusedGlobalSymbols
const config = {
    RequestNotificationPermission,
    getBetbookPostsAuthorRoute: () => COMMUNITY_POSTS_AUTHOR
};

function BetbookProfileDialog({ avatarId, nickname }) {
    useEffect(() => loadProfile(nickname), [nickname]);
    const { subscribe } = useReframe();
    const userData = subscribe(accountUserData$);
    const profile = subscribe(profile$(nickname));
    const following = profile && subscribe(betbookSubscription$(nickname));
    const staticUrl = getConfigProperty('static.url');

    function onClose() {
        scrollBody(true);
    }

    return (
        <Docked onClose={onClose}>
            <DialogBody className="betbook-profile-dialog-body">
                <BetbookProfileProvider config={config}>
                    {profile ? (
                        <BetbookProfile
                            key={nickname}
                            avatarId={avatarId}
                            nickname={nickname}
                            profile={profile}
                            following={following}
                            staticUrl={staticUrl}
                            showSubscriptionButton={userData?.nickname === nickname}
                            onMobile
                        />
                    ) : null}
                </BetbookProfileProvider>
            </DialogBody>
        </Docked>
    );
}

export default BetbookProfileDialog;
